import { State } from '@/store/state'
import { GetterTree } from 'vuex'
import { TrinketPoint } from '@/domain/models/TrinketPoint'
import { calculatePixelsFromPosition } from '@/domain/Utils'
import { TrinketLine } from '@/domain/models/TrinketLine'
import { TrinketText } from '@/domain/models/TrinketText'

export interface Getters {
    isTrinketGridEmpty (state: State): boolean
    trinketGridPoints (state: State): TrinketPoint[]
    trinketGridLines (state: State): TrinketLine[]
    trinketGridTexts (state: State): TrinketText[]
    trinketGridCurrentLine (state: State): TrinketLine | undefined
}

function mapLineToPixels (l: TrinketLine, state: State) {
    const line: TrinketLine = { ...l }

    line.x = calculatePixelsFromPosition(line.x, state.configuration.grid.width)
    line.y = calculatePixelsFromPosition(line.y, state.configuration.grid.width)
    line.x2 = calculatePixelsFromPosition(line.x2, state.configuration.grid.width)
    line.y2 = calculatePixelsFromPosition(line.y2, state.configuration.grid.width)

    return line
}

export const getters: GetterTree<State, State> & Getters = {
    isTrinketGridEmpty (state: State): boolean {
        return state.trinketGrid.points.length === 0 &&
            state.trinketGrid.lines.length === 0 &&
            state.trinketGrid.texts.length === 0
    },
    trinketGridPoints (state: State): TrinketPoint[] {
        return state.trinketGrid.points.map(p => {
            const point: TrinketPoint = { ...p }

            point.x = calculatePixelsFromPosition(point.x, state.configuration.grid.width)
            point.y = calculatePixelsFromPosition(point.y, state.configuration.grid.height)

            return point
        })
    },
    trinketGridLines (state: State): TrinketLine[] {
        return state.trinketGrid.lines.map(l => mapLineToPixels(l, state))
    },
    trinketGridTexts (state: State): TrinketText[] {
        return state.trinketGrid.texts.map(t => {
            const text: TrinketText = { ...t }

            text.x = calculatePixelsFromPosition(text.x, state.configuration.grid.width)
            text.y = calculatePixelsFromPosition(text.y, state.configuration.grid.height)

            return text
        })
    },
    trinketGridCurrentLine (state: State): TrinketLine | undefined {
        if (state.trinketGrid.currentLine) {
            return mapLineToPixels(state.trinketGrid.currentLine, state)
        }
    }
}
